<template>
<div class="chapter">
<div class="inner_page">
<p class="first">A science is any discipline in which the fool of this generation can go beyond the point reached by the genius of the last generation.</p>
<p class="right">Max Gluckman</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epigraph.vue?d75bee56